import { render, staticRenderFns } from "./DossierEditForm.vue?vue&type=template&id=99e418de&"
import script from "./DossierEditForm.vue?vue&type=script&lang=js&"
export * from "./DossierEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports